app.controller('studentWelcome4Ctrl', [
    '$scope', '$interval', 'gameService', '$state', function ($scope, $interval, gameService, $state) {
        var vm = this;

        vm.gameService = gameService;

        var now = new Date();
        var startTime = vm.gameService.startTime;
        var timeRemainingMsecs = startTime.getTime() - now.getTime();
        vm.timeRemainingSecs = parseInt(timeRemainingMsecs / 1000.0, 10);

        vm.canProceed = false;
        $scope.$parent.enabledPages[3] = false;

        vm.updateClockDisplay = function() {
            var trs = vm.timeRemainingSecs;
           
            var hr = parseInt(Math.floor(trs / 3600));
            trs -= (hr * 3600);

            var mr = parseInt(Math.floor(trs / 60));
            trs -= (mr * 60);
            
            vm.daysRemain = Math.floor(hr / 24.0);
            vm.hoursRemain = hr;
            vm.minutesRemain = mr;
            vm.secondsRemain = trs;
        }

        vm.updateCanProceed = function() {
            var trs = vm.timeRemainingSecs;
            var enabled = trs <= 0;
            vm.canProceed = enabled;
            $scope.$parent.enabledPages[3] = enabled;
        }

        vm.updateClockDisplay();
        vm.updateCanProceed();

        vm.countdownId = $interval(function() {
            vm.timeRemainingSecs -= 1;
            vm.updateClockDisplay();
            vm.updateCanProceed();
        }, 1000);

        $scope.$on('$destroy', function() {
            $interval.cancel(vm.countdownId);
        });

        vm.prev = function() {
            $scope.$parent.prevPage();
        }

        vm.next = function() {
            $scope.$parent.nextPage();
        }
   }
]);
